import { Type } from 'class-transformer';
import { ArrayMaxSize, ArrayMinSize, IsArray, ValidateNested } from 'class-validator';

import { MAX_BULK_DRAFT_ORDERS } from './draft-bulk.constants';
import { UpdateDraftItemDto } from './update-draft-item.dto';

export class UpdateDraftsBulkDto {
  /**
   * Array of draft update payloads to process in a single transactional request. Min 1 Max 1500.
   */
  @IsArray()
  @ArrayMinSize(1)
  @ArrayMaxSize(MAX_BULK_DRAFT_ORDERS)
  @ValidateNested({ each: true })
  @Type(() => UpdateDraftItemDto)
  public drafts: UpdateDraftItemDto[];
}
